import(/* webpackMode: "eager" */ "/usr/src/src/app/[store]/template.jsx");
